<!--

This is a utility module that lets you create text with an icon off to the
left. It provides a clean look, and lines the text up for you beside the icon.

Editable parameters: icon, color, size. The icon is a material icon from
Google's collection. Check here: https://material.io/icons/ . The size
is based on em's, and is optional.

Example usage

<icon-text icon="event" color="blue5" size="2">
  <p>
    Text here
  </p>
</icon-text>

-->

<template>
  <div class="icon-wrap">
    <i v-bind:class="{[iconColor] : true}" class="material-icons">{{icon}}</i> 
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      iconColor: ""
    }
  },
  props: ['icon','color'],
  created: function() {
    this.changeColor()
  },
  methods: {
    changeColor: function() {
      this.iconColor = "text-" + this.color
    }
  }
}
</script>

<style scoped>

.icon-wrap {
  position: relative;
  padding-left: 2.0em;
}

.icon-wrap i {
  color: #6c757d;
  position: absolute;
  left: 0;
}

</style>
